<template>
<div class="chapter">
<div class="inner_page">
<p class="noindenta">Thank you for buying this ebook, published by NYU Press.</p>
<p class="noindentt1">Sign up for our e-newsletters to receive information about forthcoming books, special discounts, and more!</p>
<p class="noindentt1"><a class="nounder" href="http://visitor.r20.constantcontact.com/manage/optin/ea?v=001KZi1d-co_IgG73nIY9WRDzh9DJJyEE2O6VvzPleP3DWuoH1L7zNGEwJ2ebEmTTkZeUb8IYeZv2Ta39CFZxqnA8WlTuerSkd0AgpeHhm1RWSGXrC7_LnQ-mZo5QgT3m6z" target="_blank"><strong><span class="button">Sign Up!</span></strong></a></p>
<h3 class="h3a"><strong>About NYU Press</strong></h3>
<p class="noindentt">A publisher of original scholarship since its founding in 1916, New York University Press Produces more than 100 new books each year, with a backlist of 3,000 titles in print. Working across the humanities and social sciences, NYU Press has award-winning lists in sociology, law, cultural and American studies, religion, American history, anthropology, politics, criminology, media and communication, literary studies, and psychology.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abtnyup_press.vue?61695229